<template>
  <div class="imgBox min-w-1400">
    <div class="imgBox1 min-w-1400">
      <div class="img1 max-w-1400">
        <p class="imgItem1">Acuerdo de privacidad</p>
        <!-- <img :src="importedImg1" :alt="altText" class="imgItem1" /> -->
      </div>
    </div>
    <div class="imgBox2 min-w-1400">
      <div class="img2 max-w-1400">
        <!-- <h1>Cam kết bảo mật</h1> -->
        <!-- <div class="title-line"></div> -->
        <div class="textBox" style="white-space: pre-wrap">{{ text }}</div>
      </div>
    </div>
  </div>
</template>

<script>
// import importedImg1 from "@/page/passmorecompany/components/img/4_1.png";

export default {
  data() {
    return {
      altText: "protocolTitle",
      // importedImg1: importedImg1,
      text: `Logcre Préstamo  (en adelante denominado "nosotros", "nos" o "esta Aplicación") es una plataforma de servicios financieros que opera en México, enfocada en brindar a los usuarios servicios de préstamos personales. Esta aplicación es desarrollada y mantenida por Logra y Crece, S.A. de C.V., SOFOM, E.N.R.

Damos gran importancia a su información personal y privacidad, y de acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP) y otras leyes y regulaciones pertinentes, recopilamos, usamos, almacenamos y protegemos los datos que usted proporciona al utilizar esta aplicación y servicios relacionados.

Esta Política de Privacidad tiene como objetivo informarle claramente cómo procesamos su información personal cuando visita o utiliza esta Aplicación y Servicios, y explicarle sus derechos en términos de protección de datos personales. Al acceder y utilizar esta aplicación, usted indica que ha comprendido y aceptado el contenido de esta política.

Toda la información del usuario se transmitirá de forma segura, de forma encriptada y se cargará en nuestro servidor: https://www.lograycrece.com.

Conservamos su información sólo durante el tiempo requerido por la ley y para los fines para los que fue recopilada. Si desea eliminar sus datos personales de inmediato, comuníquese con nuestro Centro de Atención al Cliente a través del correo electrónico: market@lograycrece.com.

Información del producto
Monto del préstamo: Máximo  $20,000 MXN
Plazo del préstamo: 93-365 días
La tasa de interés diaria más baja es de solo el 0,05%.
Tasa de interés: La tasa de porcentaje anual (APR) máxima es del 21%/año
No hay otros cargos
Por ejemplo:
Si pides prestados  $20,000 MXN a 180 días a una tasa de interés anual del 18.25%, entonces
Tasa de interés mensual: 18,25%/12=1,52%
Interés mensual:  MXN $20,000 * 18.25%/12= MXN $ 304.16
Monto de pago mensual:  MXN $ 20,000/6 +  MXN $ 20,000*18.25%/12= MXN $ 3,637.5
Interés total:  MXN $ 20,000 * 18.25%/12*6= MXN $ 1,825
Cuotas a devolver:  MXN $ 20,000 +  MXN $ 20,000*18.25%/12*6= MXN $ 21,825

(1). Comprensión de la información recopilada de los usuarios

1. Información personal: Cuando un usuario se registra o inicia sesión en la plataforma Logcre Préstamo , para verificar su identidad y garantizar la seguridad de su cuenta, recopilaremos la siguiente información personal de acuerdo con las leyes y regulaciones mexicanas: nombre, género, fecha de nacimiento, CURP o RFC, información de su documento de identificación oficial (como número de INE y fotografía), información de su tarjeta bancaria, nivel educativo, estado civil, información de contacto (incluyendo domicilio, correo electrónico y número de teléfono móvil), foto de selfie o de reconocimiento facial, etc. Esta información se utilizará para la verificación de identidad, la evaluación de riesgo crediticio y la prevención del fraude.

2. Información de contacto: Cuando solicita un préstamo en la plataforma Logcre Préstamo , Logcre Préstamo  necesita recopilar 3 contactos de emergencia para verificación de identidad y prevención de fraude. Puede ingresar manualmente o seleccionar entre los contactos (sólo se accederá a los contactos seleccionados). Puede solicitarnos que eliminemos los datos relevantes en cualquier momento.

3.Información financiera: Para comprobar mejor su situación financiera y ayudar a evaluar su solvencia, necesitamos recopilar: información de pago, como información de la cuenta de pago y autorización de pago, incluido el número de tarjeta bancaria del usuario. De esta manera, luego de que el usuario complete la evaluación crediticia, el departamento de productos crediticios podrá transferir el monto que solicitó a su cuenta con base en la información financiera que usted proporcionó.

4. Información de la cámara: Al solicitar un préstamo en Logcre Préstamo , deberá cargar su foto y datos faciales. La aplicación sólo recopila esta información para ayudarnos a confirmar la identidad del usuario. Nunca se comparte con terceros.

5. Información de la imagen: cuando los usuarios se comunican con el servicio de atención al cliente y necesitan cargar fotos para reflejar un problema, Logcre Préstamo  puede seleccionar las fotos cargadas del álbum para garantizar la integridad de la función. Esta información no se utilizará para ningún otro propósito sin su permiso.

6. Calendario: Para ayudarle a administrar su cronograma de pagos y establecer recordatorios, podremos acceder a la información de su calendario con su autorización. Este permiso sólo se utiliza para registrar asuntos relacionados con el préstamo. No se recopilará ni utilizará el contenido del calendario que no esté relacionado con esta aplicación. Puede desactivar este permiso en la configuración del dispositivo en cualquier momento.

8. Información de ubicación: Cuando utilice el servicio Logcre Préstamo , recopilaremos su información de ubicación para análisis técnico, optimización de la visualización de nuestro contenido y servicios regionales personalizados para mejorar su experiencia y satisfacción. Tenga en cuenta que solo obtenemos la ubicación borrosa del usuario.

9. Información del dispositivo: Para brindar servicios más estables y seguros, Logcre Préstamo  puede recopilar información relacionada con el dispositivo que utiliza, incluido el modelo del dispositivo, la versión del sistema operativo, el nombre del dispositivo, el idioma del sistema, el identificador del dispositivo (como el Identificador para anunciantes, IDFA o el Identificador para proveedor, IDFV), la dirección IP, la información del operador y la zona horaria del dispositivo. Recopilamos esta información para optimizar el rendimiento del producto, mejorar la experiencia de compatibilidad y garantizar que la aplicación funcione correctamente en su dispositivo.

10.Recopilación de otra información no personal: Podemos recopilar automáticamente cierta información no personal en función de su comportamiento de uso en la plataforma Logcre Préstamo , como la dirección IP del dispositivo, el tiempo de acceso, las páginas que navegó, las URL que visitó antes y después, el idioma del dispositivo, el tipo de sistema operativo y la información del navegador. Esta información se analizará de forma agregada para comprender las preferencias y los patrones de comportamiento de los usuarios, lo que nos ayudará a optimizar el rendimiento del servicio, mejorar la experiencia del usuario y garantizar la seguridad de la plataforma. Tenga en cuenta que esta información no se utilizará para identificar personas.


(2) Cómo garantizar la seguridad de los datos

Nos esforzamos por garantizar la seguridad de sus datos personales a través de estrictas medidas de seguridad interna e implementación de políticas y medidas y controles de seguridad de red adecuados para garantizar la confidencialidad, integridad y disponibilidad de sus datos e información personal. También requerimos que nuestros empleados y contratistas externos cumplan con nuestras políticas y estándares de privacidad aplicables y que tengan cuidado al usar, enviar o transmitir sus datos personales. También utilizamos tecnologías de seguridad avanzadas para proteger sus datos personales, incluyendo, entre otras: (1) detección de intrusiones; (2) detección de virus; (3) capa de conexión segura; (4) cifrado de datos; y (5) cierre de sesión automático.

La Compañía valora los datos personales recopilados, utilizados, retenidos y almacenados a través de la Aplicación, y la Compañía ha implementado medidas técnicas, organizativas y físicas para proteger sus datos personales. Todos los datos recopilados se cargarán y almacenarán en https://www.lograycrece.com. Todos los datos recabados serán cargados y almacenados en servidores seguros ubicados en México, en cumplimiento con la normativa de la LFPDPPP. Accedemos y utilizamos sus datos personales solo en la medida necesaria para brindarle servicios.

Utilizaremos estándares industriales generalmente aceptados para proteger la información que los usuarios nos envíen, tanto durante la transmisión como una vez que la recibimos. Sin embargo, tenga en cuenta que ningún método de transmisión a través de Internet o método de almacenamiento electrónico es 100% seguro. Por lo tanto, si bien nos esforzamos por utilizar medios comercialmente aceptables para proteger la información del usuario, no podemos garantizar su seguridad absoluta y su uso de la Aplicación es completamente bajo su propio riesgo y criterio. Tampoco podemos garantizar que dicha información del usuario no será utilizada indebidamente si nuestras medidas y protocolos de seguridad son violados por un tercero malintencionado. Además, no somos responsables y no podemos controlar completamente las acciones de otros usuarios con quienes usted elija compartir información.

(3) Cómo utilizar la información

Utilizaremos la información personal recopilada para fines tales como optimizar la calidad del servicio, mejorar la experiencia del usuario y mejorar la seguridad de la plataforma. En primer lugar, la información personal recopilada puede ayudarnos a analizar las preferencias del usuario y mejorar la funcionalidad de la aplicación. Por ejemplo, comprender los hábitos de uso de los usuarios y las funciones populares puede ayudarnos a ajustar el diseño de la interfaz y simplificar los pasos durante las actualizaciones para brindar una experiencia operativa más fácil de usar. En segundo lugar, con base en la información financiera y los datos crediticios recopilados, podemos ofrecer a los usuarios productos financieros más personalizados y planes recomendados, para que cada usuario pueda encontrar servicios que se adapten a sus necesidades. Además, para proteger la seguridad de los datos del usuario, utilizamos información de autenticación, información del dispositivo, ubicación y otros datos para identificar y prevenir posibles comportamientos peligrosos y garantizar la seguridad de la cuenta del usuario. Nos comprometemos a cumplir estrictamente la política de privacidad en todos los casos de uso para garantizar que la información esté debidamente protegida.

(4) Cómo almacenar la información del usuario

Carga y procesamiento de datos: Los datos recopilados se cargarán en nuestro servidor https://www.lograycrece.com para su encriptación, transmisión, almacenamiento y procesamiento;

Seguridad de los datos: Para proteger la seguridad de su información, implementamos activamente una variedad de medidas de seguridad físicas, electrónicas y administrativas estándar de la industria para proteger su información contra divulgación, daño o pérdida, incluidos SSL y datos encriptados. Almacenamiento, control de acceso a centros de datos, etc.

Seguridad de los datos: No revelaremos ninguna información que contenga datos personales a ningún tercero sin su permiso y, con su consentimiento, podremos proporcionar los productos o servicios que solicite a terceros;

(5) Finalidad de la recopilación de información

● Verificar la identidad del usuario y la autenticidad de la información, y realizar análisis de riesgo y viabilidad del préstamo.

● Proporcionar y mantener nuestros servicios.

● Enviarle anuncios y ofertas de servicios para proporcionarle bienes o servicios similares.

● Administrar nuestra aplicación/sitio web

● Satisfacer las necesidades de operación y mantenimiento de la APP, como análisis de datos, calificación crediticia del usuario, análisis del comportamiento del usuario, etc., para facilitar nuestro mantenimiento diario y mejorar la calidad del servicio.

● Investigar y detectar posibles fraudes u otras violaciones de nuestros Términos y Condiciones o esta Política de Privacidad, e intentos de dañar a nuestros usuarios o visitantes.

● Realizar efectivamente las actividades de cobro de pagos directamente o a través de terceras empresas comisionadas por nosotros.

● Detectar, prevenir y resolver problemas técnicos y brindar soporte al cliente

(6) Cambios en la Política de Privacidad

Podemos revisar y modificar esta Política de Privacidad de vez en cuando a nuestra discreción para asegurarnos de que sea coherente con nuestros desarrollos futuros y/o cambios en los requisitos legales o reglamentarios. Si decidimos modificar esta Política de Privacidad, le notificaremos dichas modificaciones publicando un aviso general en la Aplicación y/o el Sitio Web o enviándolo a la dirección de correo electrónico que figura en su cuenta. Usted acepta que es su responsabilidad revisar esta Política de Privacidad periódicamente para obtener la información más reciente sobre nuestras prácticas de protección y procesamiento de datos, y que su uso continuo de la Aplicación o el Sitio web, las comunicaciones con nosotros o el acceso y uso de los Servicios constituirán la aceptación de cualquier modificación.

(7) Protección de la propiedad intelectual

Ya sea que se indique expresamente o no, Logcre Préstamo  posee los derechos de propiedad intelectual de toda la información de dominio no público y la información de propiedad de otras partes en la Plataforma, incluidas, entre otras, marcas comerciales, patentes, derechos de autor y secretos comerciales. Esta información incluye texto, gráficos, software, audio, vídeo, datos, código fuente, diseño de plataforma, know-how, diseño de pantalla y diseño de página web. Es responsabilidad del usuario respetar los derechos de propiedad intelectual. Si el usuario comete alguna infracción o causa algún daño, asumirá toda la responsabilidad conforme a la ley y será responsable ante Logcre Préstamo .

(VIII) Derechos y obligaciones del usuario

De acuerdo con la Ley Federal de Protección de Datos Personales en Posesión de los Particulares (LFPDPPP), los usuarios tienen derecho a conocer en cualquier momento si sus datos personales están almacenados y a consultarnos para conocer su contenido, origen, verificar su exactitud o solicitar la completitud, corrección, actualización, cancelación o supresión de sus datos. Los usuarios también pueden solicitar que sus datos se conviertan en un formato anónimo o que se tomen medidas para evitar el procesamiento ilícito de sus datos, y tienen derecho a oponerse al procesamiento de sus datos por cualquier motivo legítimo. Por favor envíenos su solicitud utilizando la información de contacto que aparece a continuación. Tenga en cuenta que eliminar o quitar información puede afectar nuestra capacidad de brindarle servicios.

Usted tiene derecho a:

Derecho de acceso: Los usuarios tienen derecho a acceder a sus datos personales y obtener una copia de los mismos mientras los conservemos;
Derecho a retirar el consentimiento: Los usuarios pueden retirar su consentimiento para el procesamiento de sus datos personales y revisar, modificar y/o eliminar los datos personales que tenemos, pero es posible que necesitemos seguir conservando algunos datos según lo exijan las leyes y regulaciones. En cualquier caso, la retirada, modificación y supresión de los datos no tendrán efecto retroactivo ni afectarán la relación jurídica existente entre usted y la Aplicación;
Derecho de corrección y actualización: Si sus datos personales son inexactos o no están actualizados, tiene derecho a solicitarnos que los corrijamos o actualicemos;
Derecho de supresión: Podrás solicitarnos que eliminemos tus datos personales en esta aplicación sin infringir la ley;
Derecho a oponerse: Tiene derecho a oponerse a nuestro procesamiento de sus datos personales, en particular cuando el procesamiento sea para fines no esenciales;
Derecho a la anonimización o al bloqueo del tratamiento: En determinadas circunstancias, usted tiene derecho a solicitar que sus datos personales se transformen en un formato anónimo o a bloquear su tratamiento.

El ejercicio de los derechos anteriores deberá realizarse por escrito y enviarse a través del correo electrónico market@lograycrece.com. Una vez que recibamos su solicitud, la procesaremos y le responderemos dentro de un tiempo razonable. Tenga en cuenta que, en algunos casos, retirar el consentimiento o eliminar datos puede afectar nuestra capacidad para proporcionar los servicios pertinentes, pero no afectará nuestras obligaciones según la ley.

Usted acepta notificarnos de inmediato sobre cualquier cambio en cualquier información que nos proporcione y garantizar que nos informe sobre los cambios relevantes dentro de los 14 días calendario. Además, responderemos con prontitud a cualquier solicitud de información que le hagamos.

También debe comprender que está obligado a proporcionarnos información y datos personales de manera oportuna en las siguientes circunstancias:
No proporciona la información de usuario o los datos personales que solicitamos razonablemente;
usted se opone o retira cualquier consentimiento que podamos tener para procesar, transferir o divulgar su información a los efectos de esta Política de Privacidad (pero no para fines de marketing o promoción);
Si nosotros o nuestros afiliados tenemos evidencia razonable o sospecha de delito financiero u otros riesgos relacionados.

(9) Eliminación de cuentas e información

Logcre Préstamo  entiende la importancia de que los usuarios controlen su información personal y respetamos su derecho a solicitar la eliminación de la información de su cuenta. Los usuarios pueden realizar una solicitud para eliminar la información de su cuenta y desinstalar la aplicación directamente en la aplicación Logcre Préstamo . Alternativamente, los usuarios también pueden contactarnos a la dirección de correo electrónico market@lograycrece.com para enviar formalmente una solicitud de eliminación de datos. Una vez que se elimina la información de la cuenta de un usuario, los datos relacionados no se pueden restaurar. Logcre Préstamo  no realiza respaldo de los datos de esta cuenta. Si desea volver a utilizar los servicios de Logcre Préstamo , deberá volver a registrarse.

Le entendemos y nos comprometemos a mejorar continuamente la calidad de nuestros servicios para satisfacer sus necesidades. Logcre Préstamo  se compromete a mantener y proteger la privacidad y seguridad de sus usuarios y a garantizar que su información personal se maneje de forma transparente. Si tiene más preguntas sobre este asunto, comuníquese con nosotros y haremos todo lo posible para ayudarlo (Información de contacto: market@lograycrece.com) y haremos todo lo posible para ayudarlo.

(10) Protección de menores

Nos tomamos muy en serio la privacidad y seguridad de los menores. En nuestras aplicaciones, los menores de edad deben utilizar los servicios con precaución y operar bajo la guía de sus padres o tutores. Para proteger la información personal de menores, cumplimos estrictamente con las leyes y regulaciones pertinentes para garantizar que la información de menores no se recopilará, almacenará ni utilizará sin permiso.

No recopilaremos, utilizaremos ni divulgaremos activamente ninguna información personal de menores sin el consentimiento de sus padres o tutores legales. Si descubrimos que un usuario puede ser menor de edad y ha proporcionado información personal sin el consentimiento de sus padres o tutores, tomaremos inmediatamente medidas para eliminar esa información y suspender su cuenta. Alentamos a los padres y tutores a revisar periódicamente las actividades en línea de sus hijos para asegurarse de que comprendan las consecuencias de su comportamiento en línea y crear un entorno seguro para que utilicen Internet.

Con el fin de proteger la privacidad de los datos de los menores, hemos implementado una serie de medidas técnicas y de gestión, como el cifrado de datos, el control de acceso y el filtrado de contenidos. Además, los menores tienen derecho a solicitar la eliminación de su información personal para garantizar que su privacidad esté debidamente protegida. Creemos que proteger la privacidad y la seguridad de los menores es responsabilidad de cada desarrollador de aplicaciones y seguiremos trabajando arduamente para brindarles una experiencia digital más segura.

(11) Contáctenos

Si tiene alguna pregunta sobre esta Política, comuníquese con market@lograycrece.com. Por favor informe la violación con tantos detalles como sea posible para que podamos procesarla rápidamente.
DIRECCIÓN: MANUEL FERNANDEZ FIALLO 804 , Colonia Oaxaca Centro, C.P. 68000, Oaxaca de Juárez, Oaxaca`,
    };
  },
  created() {
    this.gotoTop();
  },
  methods: {
    gotoTop() {
      window.scrollTo({ top: 0, behavior: "smooth" });
    },
  },
};
</script>

<style scoped>
.imgBox {
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
}

.imgBox1 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

.imgBox2 {
  display: flex;
  justify-content: center;
  max-width: 1400px;
  padding-top: 40px;
  padding-bottom: 20px;
  height: 3700px;
  background-color: #ffffff;
  border-radius: 32px;
  margin: -140px auto 150px;
}

.imgBox3 {
  display: flex;
  justify-content: center;
  width: 100%;
  min-width: 1400px;
  background-color: "";
}

img {
  display: block;
}

.img1 {
  overflow: hidden;
  width: 100%;
}

.img2,
.img4 {
  overflow: hidden;
}

.img3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

.imgItem1 {
  width: 100%;
  margin-top: 0;
  margin-bottom: 0;
}

.imgItem2 {
  max-width: 100%;
}

.imgItem3 {
  width: 100%;
  overflow: hidden;
  margin-left: 0;
  margin-right: 0;
}

h1 {
  margin-top: 50px;
  margin-left: 490px;
  color: #3f4842;
  font-size: 40px;
  /* border-bottom: 5px solid #04358A; */
  display: inline-block;
}

.textBox {
  margin-top: 50px;
  margin-left: 100px;
  margin-right: 100px;
  font-size: 18px;
  color: #333333;
}

.imgBox2 {
  transform: scale(90%);
  /* transform: scale(80%); */
  margin: -150px auto 100px;
  height: 6400px;
  /* box-shadow: 0 1px 4.8px 0px rgba(246, 102, 11, 0.25); */
  /* border: 2px solid #F6660B; */
}
.textBox {
  margin-top: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
/* .imgBox2{
  border-radius: 0;
  border-top: 3px solid #7c2af8;
  border-left: 2px solid #e9e9e9;
  border-right: 2px solid #e9e9e9;
  border-bottom: 3px solid #c1c1c1;
} */
.title-line {
  width: 430px;
  /* background: url(./components/img/Group1.png); */
  /* background-repeat: no-repeat; */
  /* background-position: -150px 10px; */
  /* height: 50px; */
  /* border: 1px solid red; */
  border: 5px solid #0baf60;
  margin: 0 500px;
}

.img1 {
  /* background: radial-gradient(57.03% 57.03% at 50% 50%, #3C51A0 0%, #223479 100%); */
  height: 291px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.imgItem1 {
  color: #333333;
  font-family: "SF Pro";
  font-weight: 700;
  font-size: 52px;
  text-align: center;
}
</style>
